import { WeighedMaterialType } from '../../../constants/MaterialModels';

type WeighedMaterialTypeValue = (typeof WeighedMaterialType)[keyof typeof WeighedMaterialType];

const CEMENT_BASED_SECONDARY_BIN_FREE_FALL = 200;
const AGGREGATE_BASED_SECONDARY_BIN_FREE_FALL = 2000;

export const getSecondaryBinFreeFallForAutoTuning = (materialType: WeighedMaterialTypeValue): number => {
  if (materialType === WeighedMaterialType.Cement || materialType === WeighedMaterialType.Cementitious) {
    return CEMENT_BASED_SECONDARY_BIN_FREE_FALL;
  } else if (materialType === WeighedMaterialType.FineAggregate || materialType === WeighedMaterialType.CoarseAggregate) {
    return AGGREGATE_BASED_SECONDARY_BIN_FREE_FALL;
  }

  return 0;
};
